import InitTrainersLogic from "./Trainers.logic";

const TrainersComponent: React.FC = () => {
    const { trainers, categories, categoryPrices, form, editingId, onChange, onCategoryPriceChange, onSave, onEdit, onDelete, resetForm } = InitTrainersLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Treneri</h1>

            <div className="card">
                <h3>{editingId ? "Izmeni trenera" : "Dodaj trenera"}</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                        <label htmlFor="firstName">Ime</label>
                        <input id="firstName" type="text" placeholder="Ime..." value={form.firstName} onChange={onChange} name="firstName"></input>
                    </div>
                    <div>
                        <label htmlFor="lastName">Prezime</label>
                        <input id="lastName" type="text" placeholder="Prezime..." value={form.lastName} onChange={onChange} name="lastName"></input>
                    </div>
                    <div>
                        <label htmlFor="username">Korisničko ime</label>
                        <input id="username" type="text" placeholder="Korisničko ime..." value={form.username} onChange={onChange} name="username"></input>
                    </div>
                    <div>
                        <label htmlFor="password">{editingId ? "Nova lozinka (ostavi prazno da se ne menja)" : "Lozinka"}</label>
                        <input id="password" type="password" placeholder={editingId ? "••••••••" : "Lozinka..."} value={form.password} onChange={onChange} name="password" autoComplete="new-password"></input>
                    </div>
                    <hr />
                    <p style={{fontSize: "0.85rem", opacity: 0.7, margin: "4px 0"}}>
                        Cena po kategoriji treninga (za obračun plate trenera)
                    </p>
                    {categories.map((cat) => (
                        <div key={cat.id}>
                            <label htmlFor={`cp-${cat.id}`}>{cat.name}</label>
                            <input
                                id={`cp-${cat.id}`}
                                type="number"
                                inputMode="numeric"
                                min={0}
                                step={1}
                                placeholder="0"
                                value={categoryPrices[cat.id] ?? ""}
                                onChange={(e) => onCategoryPriceChange(cat.id, e.target.value)}
                            ></input>
                        </div>
                    ))}
                    {editingId && (
                        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
                            <input id="disabled" type="checkbox" checked={form.disabled} onChange={onChange} name="disabled" style={{width: "auto", margin: 0}}></input>
                            <label htmlFor="disabled" style={{margin: 0}}>Onemogući pristup</label>
                        </div>
                    )}
                    <button className="btn-primary" type="button" onClick={onSave}>{editingId ? "Sačuvaj izmene" : "Dodaj"}</button>
                    {editingId && <button className="btn-secondary" type="button" onClick={resetForm}>Otkaži</button>}
                </div>
            </div>

            <div className="card" style={{ marginTop: '12px' }}>
                <h3>Lista trenera</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {trainers.map((t) => {
                        const priceSummary = categories.map(cat => {
                            const cp = (t.categoryPrices || []).find((p: any) => p.trainingCategoryId === cat.id);
                            return `${cat.name}: ${cp?.price ?? 0}`;
                        }).join(" | ");
                        return (
                            <div key={t.id} style={{ borderBottom: '1px solid var(--border)', paddingBottom: '12px', opacity: t.disabled ? 0.5 : 1 }}>
                                <p className="text-align-center" style={{ fontWeight: 500 }}>
                                    {t.firstName} {t.lastName} ({t.username})
                                    {t.disabled && <span style={{marginLeft: 8, fontSize: "0.8rem", color: "var(--danger)"}}> [onemogućen]</span>}
                                </p>
                                <p className="text-align-center" style={{ fontSize: "0.85rem", opacity: 0.7, margin: "4px 0" }}>
                                    {priceSummary || "-"}
                                </p>
                                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                    <button className="btn-small btn-secondary" type="button" onClick={() => onEdit(t)}>Izmeni</button>
                                    <button className="btn-small btn-danger" type="button" onClick={() => onDelete(t.id)}>Obriši</button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TrainersComponent;
